import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShellComponent } from './shell.component';
import { AuthGuard } from '@app/@core/http/auth.guard';

const childrenRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: () => import('../home/home.module').then((m) => m.HomeModule),
  },
  {
    path: 'account-info',
    loadChildren: () => import('../account-info/account-info.module').then((m) => m.AccountInfoModule),
  },
  {
    path: 'customers',
    loadChildren: () =>
      import('../sharedComponents/licenses-table/licenses-table.module').then((m) => m.LicenseTableModule),
  },
  {
    path: 'customers/license-value/:no',
    loadChildren: () => import('../licenses/license-value/license-value.module').then((m) => m.LicenseValueModule),
  },
  {
    path: 'customers/subscription-value/:no',
    loadChildren: () =>
      import('../licenses/subscription-value/subscription-value.module').then((m) => m.SubscriptionValueModule),
  },
  {
    path: 'customers/license-mobile-keys/:no',
    loadChildren: () =>
      import('../licenses/license-mobile-keys/license-mobile-keys.module').then((m) => m.LicenseMobileKeysModule),
  },
  {
    path: 'customers/lm-units',
    loadChildren: () => import('../licenses/lm-units/lm-units.module').then((m) => m.LMUnitsModule),
  },
  {
    path: 'customers/lm-units-summary',
    loadChildren: () =>
      import('../licenses/lm-units-summary/lm-units-summary.module').then((m) => m.LMUnitsSummaryModule),
  },
  {
    path: 'invoices',
    loadChildren: () => import('../order-history/order-history.module').then((m) => m.OrderHistoryModule),
  },
  {
    path: 'user-management',
    loadChildren: () => import('../partneradmin/partneradmin.module').then((m) => m.PartnerAdminModule),
  },
  {
    path: 'saltpay-success',
    loadChildren: () => import('../saltpay/success/success.module').then((m) => m.SuccessModule),
  },
  {
    path: 'saltpay-error',
    loadChildren: () => import('../saltpay/error/errorr.module').then((m) => m.ErrorModule),
  },
  {
    path: 'saltpay-cancel',
    loadChildren: () => import('../saltpay/cancel/cancel.module').then((m) => m.CancelModule),
  },
  {
    path: 'ehf-replication',
    loadChildren: () => import('../replication/replication.module').then((m) => m.ReplicationModule),
  },
  {
    path: 'partner-program',
    loadChildren: () => import('../partner-program/partner-program.module').then((m) => m.PartnerProgramModule),
  },
  {
    path: 'admin-users',
    loadChildren: () => import('../admin/users/users.module').then((m) => m.UsersModule),
  },
  {
    path: 'admin-saltpay',
    loadChildren: () => import('../admin/saltpay/saltpay.module').then((m) => m.SaltpayModule),
  },
  // {
  //   path: 'select-partner',
  //   loadChildren: () => import('../auth/select-partner/select-partner.module').then((m) => m.SelectPartnerModule),
  // },
  {
    path: 'logs',
    loadChildren: () => import('../logs/logs.module').then((m) => m.LogsModule),
  },
  {
    path: 'unit-cancelation-logs',
    loadChildren: () =>
      import('../unit-cancelation-logs/unit-cancelation-logs.module').then((m) => m.UnitCancelationLogsModule),
  },
];

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: childrenRoutes,
    canActivate: [AuthGuard],
    // Reuse ShellComponent instance when navigating between child views
    data: { reuse: true },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ShellRoutingModule {}
